<script setup>
import { computed, ref, watch, nextTick } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const input = ref(null)
let editing = ref(false)

const props = defineProps({
  modelValue: null,
  type: {
    type: String,
    default: "text",
  },
  required: {
    type: Boolean,
  },
  errors: {
    type: Object,
    default: {},
  },
});

const emit = defineEmits(["update:modelValue", 'update']);

watch(() => props.modelValue, (newValue, oldValue) => {

});

const classObject = computed(() => ({
  'has-danger': props.errors.$error,
  'is-invalid': props.errors.$error,
}))

async function toggle() {
  editing.value = !editing.value;

  if (editing.value) {
    await nextTick();
    input.value.focus();
  }
}

function focused() {

}

function onBlur() {
  emit('update', props.modelValue);
  toggle();
}

function handleEnter() {
  input.value.blur();
}
</script>

<template>
  <div class="input-group input-group-static" :class="classObject">
    <input v-if="editing" ref="input" :type="type" :id="$attrs.id" :name="$attrs.name" :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)" :placeholder="$attrs.placeholder || ''"
      class="form-control" :disabled="$attrs.disabled" :readonly="$attrs.readonly" @focus="focused"
      @blur="onBlur" @keyup.enter="handleEnter" />

    <span v-else @click.stop="toggle">
      {{ modelValue }}
    </span>

    <small class="text-danger" style="font-size: 0.7rem; top: 40px;" v-if="errors.$error">
      {{ errors.$errors[0].$message }}
    </small>
  </div>
</template>

<style>

ul li input[type=text] {
    display: block !important;
}
</style>
